import { useContext } from 'react';
import { EditGenericEventModalContext } from './EditGenericEventModalContext';
export default function useEditGenericEventContext() {
    const context = useContext(EditGenericEventModalContext);
    if (!context) {
        throw new Error('useEditGenericEventContext must be used within a EditGenericEventModalContextProvider');
    }
    return context;
}
